import React from 'react';
import styles from '../containers/Layouts/Layout.module.css';

interface Props {}

const Spinner: React.FC<Props> = () => {
    return (
        <div className={styles.spinner} data-qaid="spinner">
            <svg
                style={{
                    margin: 'auto',
                    background: 'rgb(255, 255, 255, 0)',
                    display: 'block',
                    shapeRendering: 'auto',
                }}
                width="70px"
                height="70px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
            >
                <circle
                    cx="50"
                    cy="50"
                    fill="none"
                    stroke="#006ed9"
                    strokeWidth="10"
                    r="38"
                    strokeDasharray="179.0707812546182 61.690260418206066"
                    transform="rotate(126.264 50 50)"
                >
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        repeatCount="indefinite"
                        dur="1s"
                        values="0 50 50;360 50 50"
                        keyTimes="0;1"
                    ></animateTransform>
                </circle>
            </svg>
        </div>
    );
};

export default Spinner;
